import { render } from "./AddEditPackageModal.vue?vue&type=template&id=735db345&scoped=true"
import script from "./AddEditPackageModal.vue?vue&type=script&lang=js"
export * from "./AddEditPackageModal.vue?vue&type=script&lang=js"

import "./AddEditPackageModal.vue?vue&type=style&index=0&id=735db345&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735db345"]])

export default __exports__